import React from 'react'
import CheckboxOriginal from '../../checkbox/index'

// Public constants
export const UNCHECKED = 'unchecked'
export const PARTIAL = 'partial'
export const CHECKED = 'checked'

// Props for the original checkbox
const options = {
  [UNCHECKED]: {
    'disableProperty': false,
    'partialCheckbox': false,
    'requiredProperty': false,
    'boxStatus': 'default'
  },
  [PARTIAL]: {
    'disableProperty': false,
    'partialCheckbox': true,
    'requiredProperty': false,
    'boxStatus': 'partiallySelected'
  },
  [CHECKED]: {
    'disableProperty': false,
    'partialCheckbox': false,
    'requiredProperty': false,
    'boxStatus': 'selected'
  }
}

/**
 * Adapter for the checkbox component for use with shared status constants.
 *
 * Use:
 *
 *    import Checkbox, { UNCHECKED, PARTIAL, CHECKED } from './checkbox/Checkbox'
 *
 *    <Checkbox status={UNCHECKED} onChange={this.handleClicked} enabled />
 *
 *
 */
const Checkbox = props => { // @TODO use PureComponent
  let { status } = props

  if (!status || !(status in options)) {
    console.error('Checkbox - Unknow status:', status)
    status = UNCHECKED
  }

  const checkboxProps = options[ status ]

  checkboxProps.disableProperty = (props.enabled !== undefined) ? !props.enabled : false
  checkboxProps.requiredProperty = (props.required !== undefined) ? !props.required : false

  // Trying to wrap in button to enable keyboard nav
  // return <button style={{position:'relative', top:'-2px', marginRight: '0px', padding:'0',width:'18px',height:'19px'}} tabIndex="1"><CheckboxOriginal checkStatus={props.onChange} {...checkboxProps} /></button>

  return <CheckboxOriginal checkStatus={props.onChange} {...checkboxProps} />
}

export default Checkbox
